import React from 'react';

interface RebrandingCheckProps {
    classname?: string;
    width?: string;
    height?: string;
}
const RebrandingCheck = ({
    classname,
    width,
    height,
}: RebrandingCheckProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        className={classname}
        width={width}
        height={height}
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM5.94092 12.4725L7.35513 11.0583L10.4708 14.174L16.6448 8L18.059 9.41421L10.4708 17.0024L5.94092 12.4725Z"
            fill="#161719"
        />
    </svg>
);

export default RebrandingCheck;
